export default function ChevronRightV2({
  width = 10,
  height = 6,
  fill = 'currentColor',
  ...rest
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
      <path
        d='M1.00104 0.000514984C1.26657 0.000571251 1.5212 0.106098 1.70892 0.293882L5.00604 3.591L8.30317 0.293882C8.49201 0.111495 8.74492 0.0105753 9.00745 0.0128565C9.26997 0.0151377 9.5211 0.120438 9.70674 0.306078C9.89238 0.491719 9.99768 0.742846 9.99996 1.00537C10.0022 1.2679 9.90132 1.52081 9.71894 1.70965L5.71393 5.71466C5.52617 5.90237 5.27154 6.00781 5.00604 6.00781C4.74055 6.00781 4.48592 5.90237 4.29816 5.71466L0.293154 1.70965C0.153169 1.56962 0.0578432 1.39124 0.019228 1.19704C-0.0193882 1.00285 0.00043869 0.801562 0.0762033 0.618633C0.151968 0.435705 0.28027 0.279346 0.444885 0.169324C0.609501 0.0593023 0.803041 0.000556946 1.00104 0.000514984Z'
        fill={fill}
      />
    </svg>
  );
}
